import { useRouter } from "next/router";
import React from "react";
import Arrow from "../../../assets/RightArrow";
import Image from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";

export default function Community() {
  const router = useRouter();
  const lang = router.locale;
  const t = useTranslations("ipillion.Download");
  return (
    <>
      <div className="relative w-full lg:mt-0 -mt-10 xsm:h-[700px] mds:h-[900px] h-[700px] sm:h-[800px] lg:h-[500px] overflow-hidden ">
        <div className="bg-[#002046] lg:-skew-y-3 -skew-y-6 z-10 [400px] lg:h-[70px] h-[60px] w-full absolute bottom-0"></div>
        <div className="bg-[#EBD773] -skew-y-1 z-20 [400px] h-[60px] w-full absolute -bottom-6"></div>
        <div className=" absolute bottom-0 z-30 flex w-full justify-center items-center  flex-col lg:flex-row mx-auto">
          <div className="max-w-[90rem]  w-full px-[9%]  mx-auto grid grid-cols-12 ">
            <div className=" max-w-[500px]  lg:col-span-6 col-span-12">
              <div>
                <h2 className="lg:font-[590] font-[700] lg:text-[40px] text-[30px] whitespace-nowrap  text-[#1D1D1B]">
                  {t("header")}
                </h2>
                <hr
                  className={`h-[5px] bg-[#C29D3E] border-none rounded-[22.5px] w-[138px]`}
                ></hr>
              </div>
              <div className="grid grid-cols-12 lg:gap-y-0 gap-y-3">
                <div className="col-span-12 lg:my-[2rem] mt-5 grid grid-cols-12 items-center ">
                  <div className="col-span-12 lg:col-span-6">
                    <p className="whitespace-nowrap text-left max-w-[40%] text-[18px] leading-[25px] font-[590] text-[#1D1D1B]">
                      {t("sub-header")}
                    </p>
                  </div>
                  <div className="col-span-12 lg:col-span-6">
                    <Link href={"/contact"}>
                      <button className="rounded-[47px] border-[#C29D3E] border-[2px]  w-[188px] h-[48px] flex justify-around items-center">
                        <div>
                          <p className="text-[16px]">{t("button")}</p>
                        </div>
                        <div
                          className={`${
                            lang == "ar" ? "-scale-x-100 pr-3" : "pl-3"
                          }`}
                        >
                          <Arrow />
                        </div>
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="w-[400px] text-[26px]">
                  {lang == "ar" ? (
                    <p>قريبا على...</p>
                  ) : (
                    <p>Coming soon to...</p>
                  )}
                </div>
                <div className="col-span-12 flex justify-start gap-8 my-3">
                  <div className="lg:w-[189px] w-[178px] h-fit">
                    <Image
                      src={"/projects/android.png"}
                      layout="responsive"
                      width={189}
                      height={56}
                      quality={100}
                      className=" object-cover"
                    />
                  </div>
                  <div className="w-[189px] h-fit">
                    <Image
                      src={"/projects/ios.png"}
                      layout="responsive"
                      width={189}
                      height={56}
                      quality={100}
                      className=" object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:block relative lg:col-span-6 col-span-12 items-center">
              <Image
                src="/projects/Ezcredit/hand.png"
                alt="ipillion Community"
                width={473}
                height={442}
                className="object-cover"
              />
            </div>
            <div className=" lg:hidden relative lg:col-span-6 col-span-12 ">
              <Image
                src="/projects/Ezcredit/hand.png"
                alt="ipillion Community"
                layout="responsive"
                width={277}
                height={258}
                className="object-cover"
                quality={100}
              />
            </div>
          </div>
        </div>
        <div className="bg-[#C29D3E] lg:skew-y-2 skew-y-6 z-30 right-3 [400px] lg:h-[60px] h-[50px] w-full -mr-3 -pr-3 absolute -bottom-8"></div>
      </div>
    </>
  );
}
